// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo } from 'react'
import AccountSettingsEditMode from '../AccountSettingsEditMode/AccountSettingsEditMode'
import { GeneralInformation } from '../GeneralInformation/GeneralInformation'

export const AccountSection = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isEditMode,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    toggleIsEditMode,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setNewActiveTab,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    newActiveTab,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setIsChangedData,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setSaveChangesFromPopUp,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    saveChangesFromPopUp,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setIsConfirmationPopUpOpened,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    phoneInputRef,
  }) => {
    if (isEditMode) {
      return (
        <AccountSettingsEditMode
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          setNewActiveTab={setNewActiveTab}
          newActiveTab={newActiveTab}
          setIsChangedData={setIsChangedData}
          setSaveChangesFromPopUp={setSaveChangesFromPopUp}
          saveChangesFromPopUp={saveChangesFromPopUp}
          setIsConfirmationPopUpOpened={setIsConfirmationPopUpOpened}
          toggleIsEditMode={toggleIsEditMode}
          phoneInputRef={phoneInputRef}
        />
      )
    }

    return <GeneralInformation toggleIsEditMode={toggleIsEditMode} />
  },
)
